import Cookies from 'js-cookie'
import { API } from '../../App';



export const getServiceProvider = async (payload,token) => {
      let result
      try {
            result = await API.post("/vpn-dropdown-list", payload, { headers: { authorization: `${token}` } })

      } catch (error) {
            console.log(error)
      }
      return result?.data
}
export const getCountry = async (payload,token) => {
      let result
      try {
            result = await API.post("/country-list", payload, { headers: { authorization: `${token}` } })

      } catch (error) {
            console.log(error)
      }
      return result?.data
}
export const getVpn = async (payload,token) => {
      let result
      try {
            result = await API.post("/get-vpn-data", payload, { headers: { authorization: `${token}` } })

      } catch (error) {
            console.log(error)
      }
      return result?.data
}
export const getViewVPN = async (payload,token) => {
      let result
      try {
            result = await API.post("/view-countries-data", payload, { headers: { authorization: `${token}` } })

      } catch (error) {
            console.log(error)
      }
      return result?.data
}
export const vpnStatusUpdate = async (payload,token) => {
      let result
      try {
            result = await API.post("/update-vpn-status", payload, { headers: { authorization: `${token}` } })

      } catch (error) {
            console.log(error)
      }
      return result?.data
}
export const addVpn = async (payload,token) => {
      let result
      try {
            result = await API.post("/add-countries-data", payload, { headers: { authorization: `${token}` } })

      } catch (error) {
            console.log(error)
      }
      return result?.data
}
export const deleteServiceProvider = async (payload,token) => {
      let result
      try {
            result = await API.post("/delete-service-provider", payload, { headers: { authorization: `${token}` } })

      } catch (error) {
            console.log(error)
      }
      return result?.data
}
export const deleteVpn = async (payload,token) => {
      let result
      try {
            result = await API.post("/delete-vpn", payload, { headers: { authorization: `${token}` } })

      } catch (error) {
            console.log(error)
      }
      return result?.data
}
